import { SafePromise, SafeType } from '@benzinga/safe-await';
import { RestfulClient, Session } from '@benzinga/session';
import { TrendingTopic } from '../entities';
import { TrendingTopicsEnvironment } from '../environment';
import { trendingTopicsRoutes } from './routes';
import { TrendingTopicsTransport } from './types';

export class TrendingTopicsUpstreamRestful extends RestfulClient implements TrendingTopicsTransport {
  constructor(session: Session) {
    super(session.getEnvironment(TrendingTopicsEnvironment).upstreamUrl, session, {
      authorizationSession: true,
      'x-device-key': true,
    });
  }

  getTrendingTopics = (): SafePromise<TrendingTopic[]> => {
    const url = this.URL(trendingTopicsRoutes.topics.upstream);
    return this.fetch(url.toString(), { allowsAnonymousAuth: true, credentials: 'same-origin' }).then(
      async resp => (resp.ok ? { ok: await resp.ok.json() } : { err: resp.err }) as SafeType<TrendingTopic[]>,
    );
  };

  getTrendingIndiaTopics = (): SafePromise<TrendingTopic[]> => {
    const url = this.URL('api/trending-india/topics');
    return this.get(url, {
      allowsAnonymousAuth: true,
      credentials: 'same-origin',
    });
  };
}
